module.exports = __webpack_public_path__ + "static/media/GSA_LogoMitZusatz_NegativAufMidnightGreen_RGB_XXS.56116a68.svg";